import { View, type ViewProps } from "react-native";

/**
 * Web stub for KeyboardAvoidingView.
 * On native, this is replaced by the react-native-keyboard-controller version.
 * On web, keyboards don't overlap content, so we render a View that forwards layout props.
 */
export const KeyboardAvoidingView = ({
  children,
  behavior: _behavior,
  keyboardVerticalOffset: _keyboardVerticalOffset,
  contentContainerStyle: _contentContainerStyle,
  enabled: _enabled,
  ...viewProps
}: ViewProps & {
  behavior?: string;
  keyboardVerticalOffset?: number;
  contentContainerStyle?: ViewProps["style"];
  enabled?: boolean;
}) => <View {...viewProps} data-sentry-element="View" data-sentry-component="KeyboardAvoidingView" data-sentry-source-file="KeyboardAvoidingView.tsx">{children}</View>;